import PatientFileUploadModel from '@/Models/PatientFileUploadModel';

/**
 * Map remote PatientFileUpload to local
 * @param {object} dtoPatientFileUpload
 * @returns {PatientFileUploadModel}
 */
export const PatientFileUploadResponse = dtoPatientFileUpload => {
  return new PatientFileUploadModel(dtoPatientFileUpload);
};

/**
 * Map remote PatientFileUploads to local
 * @param {object[]} dtoPatientFileUploads
 * @returns {PatientFileUploadModel[]}
 */
export const PatientFileUploadsResponse = dtoPatientFileUploads => {
  return dtoPatientFileUploads.map(dto => PatientFileUploadResponse(dto));
};
